import React from "react";
import { X, RotateCcw } from "lucide-react";

interface SectionToggleWrapperProps {
  sectionId: string;
  title?: string;
  hidden: boolean;
  onHide: (sectionId: string) => void;
  onRestore: (sectionId: string) => void;
  className?: string;
  children: React.ReactNode;
}

export const SectionToggleWrapper: React.FC<SectionToggleWrapperProps> = ({
  sectionId,
  title,
  hidden,
  onHide,
  onRestore,
  className = "",
  children,
}) => {
  if (hidden) {
    return (
      <div
        className={`border-2 border-dashed border-gray-300 dark:border-gray-700 rounded-lg p-4 bg-white/60 dark:bg-gray-800/40 ${className}`.trim()}
        data-exclude-from-export
      >
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="text-sm text-gray-600 dark:text-gray-400">
            {title ? `${title} hidden` : "Section hidden"}
          </div>
          <button
            type="button"
            onClick={() => onRestore(sectionId)}
            className="inline-flex items-center gap-2 rounded-md border border-blue-200 bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-700 transition hover:bg-blue-100 dark:border-blue-900 dark:bg-blue-900/30 dark:text-blue-200 dark:hover:bg-blue-900/50"
          >
            <RotateCcw className="h-4 w-4" /> Restore
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={`relative group ${className}`.trim()}>
      <div
        className="absolute top-3 right-3 z-10 flex gap-2 opacity-0 transition-opacity group-hover:opacity-100"
        data-exclude-from-export
      >
        <button
          type="button"
          onClick={() => onHide(sectionId)}
          className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-white/90 text-gray-600 shadow hover:bg-white hover:text-gray-900 dark:bg-gray-800/90 dark:text-gray-200 dark:hover:bg-gray-700"
          title={title ? `Remove ${title}` : "Remove section"}
        >
          <X className="h-4 w-4" />
        </button>
      </div>
      {children}
    </div>
  );
};
